import eventBus from '@/utils/event-bus.js';
import store from '@/store';
const publicPath = process.env.BASE_URL

export const buttonStartGoal = `
    <div class="smr-button smr-button--tiny smr-button--outline--grey smr-button--round smr-button__icon js-pin-drop-button" data-position="start" data-tracking-label="Set as Starting Point" data-ga4-tracking-label="starting_point">
        <span class="smr-button__icon">
            <img src="${publicPath}/images/icons/icon-start-target.svg" alt="Starting Point" />
        </span>
        <span class="smr-button__text">Als Start</span>
    </div>

    <div class="smr-button smr-button--tiny smr-button--outline--grey smr-button--round smr-button__icon js-pin-drop-button" data-position="end" data-tracking-label="Set as Destination" data-ga4-tracking-label="destination">
        <span class="smr-button__icon">
            <img src="${publicPath}/images/icons/icon-end-target.svg" alt="Set as Destination" />
        </span>
        <span class="smr-button__text">Als Ziel</span>
    </div>
`;

export const buttonStartInterimGoal = `
    <div class="smr-button smr-button--tiny smr-button--outline--grey smr-button--round smr-button__icon js-pin-drop-button" data-position="start" data-tracking-label="Set as Starting Point" data-ga4-tracking-label="starting_point">
        <span class="smr-button__icon">
            <img src="${publicPath}/images/icons/icon-start-target.svg" alt="Starting Point" />
        </span>
        <span class="smr-button__text">Als Start</span>
    </div>

    <div class="smr-button smr-button--tiny smr-button--outline--grey smr-button--round smr-button__icon js-pin-drop-button" data-position="between" data-tracking-label="Set as Stop" data-ga4-tracking-label="stop">
        <span class="smr-button__icon">
            <img src="${publicPath}/images/icons/icon-plus.svg" alt="Set as Stop" />
        </span>
        <span class="smr-button__text">Als Zwischenziel</span>
    </div>
    <div class="smr-button smr-button--tiny smr-button--outline--grey smr-button--round smr-button__icon js-pin-drop-button" data-position="end" data-tracking-label="Set as Destination" data-ga4-tracking-label="destination">
        <span class="smr-button__icon">
            <img src="${publicPath}/images/icons/icon-end-target.svg" alt="Set as Destination" />
        </span>
        <span class="smr-button__text">Als Ziel</span>
    </div>
`;

export function createButtonEditRemove(waypointIndex, showRemoveButton) { 
    return `
        <div class="smr-button smr-button--outline--grey smr-button--tiny smr-button--round js-pin-drop-button" data-action="edit" data-waypoint-index="${waypointIndex}">
            <span class="smr-button__icon">
                <img src="${publicPath}/images/icons/icon-edit.svg" alt="Bearbeiten" />
            </span>
            <span class="smr-button__text">Bearbeiten</span>
        </div>
        ${showRemoveButton ? `
            <div class="smr-button smr-button--outline--grey smr-button--tiny smr-button--round js-pin-drop-button" data-action="remove" data-waypoint-index="${waypointIndex}">
                <span class="smr-button__icon">
                    <img src="${publicPath}/images/icons/icon-minus-circle.svg" alt="Löschen" />
                </span>
                <span class="smr-button__text">Entfernen</span>
            </div>
        ` : '' }
    `
}

export function popupContent(data, buttonsHTML, favourites = false, type = 'pindrop') {
    let alreadyFavourited = false
    let matchingFavourite = false
    if(favourites && favourites.length > 0) {
        const dataId = data.locationId ? data.locationId : data.id
        matchingFavourite = favourites.filter(favourite => favourite.objectId === dataId)
        if(matchingFavourite && matchingFavourite.length > 0) {
            alreadyFavourited = true
        }
    }
    const favouriteJsonString = JSON.stringify(JSON.stringify(data)).replace(/[']/g, "&#39;") // need to escape single quotes for the json string to avoid errors
    const showSharing = false
    return `
        <div class="pin-drop-popup__content">
            <div class="pin-drop-popup__actions">
                ${type === 'pindrop' ? `
                    ${showSharing ? `
                    <div class="pin-drop-popup__actions__item">
                        <img src="${publicPath}/images/icons/icon-share.svg" alt="Teilen" />
                    </div>` : ''}
                    <div class="pin-drop-popup__actions__item js-pin-drop-favourite ${alreadyFavourited ? 'is-active' : ''}" data-favourite-location='${favouriteJsonString}' ${alreadyFavourited ? `data-favourite-id="${matchingFavourite[0].id}"` : ''}>
                        <img src="${publicPath}/images/icons/icon-star.svg" alt="Favourit" class="star" />
                        <img src="${publicPath}/images/icons/icon-star-outline.svg" alt="Favourit" class="star-outline" />
                    </div>
                ` : '' }
                <div class="pin-drop-popup__actions__item js-pin-drop-close" data-type="${type}">
                    <img src="${publicPath}/images/icons/icon-close.svg" alt="Schließen" />
                </div>
            </div>
            <div class="pin-drop-popup__info">
                <div class="pin-drop-popup__info__title h2">${!data.comment && data.label ? data.label : data.name}</div>
                <div class="copy-light">${data.realLocation && data.comment ? data.comment : `Koordinaten <br> ${data.lat}, ${data.lon}`}</div>
            </div>
            <div class="pin-drop-popup__buttons">
                ${buttonsHTML}
            </div>
        </div>
    `
} 

export function loader() {
    return `
        <div class="pin-drop-popup__content pin-drop-popup__content--loader">
            <div class="loader">
                ${Array(7).join(0).split(0).map(() => `
                    <span></span>
                `).join('')}
            <div>
        </div>
    `
}

export function getPinDropOffsets(mapContainer, pinDropElement) {
    // get container properties
    const containerClientRect = mapContainer.getBoundingClientRect()
    const containerTop = containerClientRect.top;
    const containerBottom = containerTop + containerClientRect.height;
    const containerLeft = containerClientRect.left
    const containerRight = containerLeft + containerClientRect.width

    // get element properties
    const elementClientRect = pinDropElement.getBoundingClientRect()
    const elementTop = elementClientRect.top; // change here
    const elementBottom = elementTop + elementClientRect.height;
    const elementLeft = elementClientRect.left
    const elementRight = elementClientRect.left + elementClientRect.width;

    const offsets = {
        top: containerTop - elementTop,
        left: containerLeft - elementLeft,
        right: elementRight - containerRight,
        bottom: elementBottom - containerBottom
    }

    return offsets;
}

export async function togglePinDropFavourite(element) {
    const active = element.classList.contains('is-active')
    const data = element.dataset.favouriteLocation ? JSON.parse(JSON.parse(element.dataset.favouriteLocation)) : false
    const favouriteId = element.dataset.favouriteId ?? false
    if(active && favouriteId) {
        eventBus.$emit('showFavouriteRemovalConfirmation', () => { deleteFavourite(element, favouriteId) })
    } else {
        eventBus.$emit('showFavouritesPanel', data);
    }
}

async function deleteFavourite(element, favouriteId) {
    await store.dispatch('removeFavourite', favouriteId)
    element.classList.remove('is-active')
}